import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import HeaderWrapper from "../Header/HeaderWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";
import Spinner from "../Spinner";
import FooterWrapper from "../Footer/FooterWrapper";
import { SendPostRequest } from "../../http";

function GalleryDetail() {
  const [galleryDetail, setGalleryDetail] = useState([]);
  const [myLoader, setMyLoader] = useState(true);
  const sitedata = useSelector((store) => store.global.loginData);
  const { id } = useParams();

  const fetchGalleryDetail = async () => {
    try {
      setMyLoader(true);
      const response = await SendPostRequest("gallery/details", {
        images_uid: id,
      });
      setGalleryDetail(response?.data || []);
    } catch (error) {
      console.error("Error fetching gallery details:", error);
    } finally {
      setMyLoader(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchGalleryDetail();
  }, []);

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="Gallery Details" Image="theme-2-banner-gallery.webp" />

      {/* <div className="container">
        {myLoader ? (
          <div className="text-center py-5">
            <Spinner />
          </div>
        ) : galleryDetail?.length > 0 ? (
          <>
            <div className="row">
              <div className="offset-md-2 col-md-8 py-5">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-40">
                    <h2 className="title text-uppercase ">
                      {galleryDetail?.[0]?.gallery_title}
                      <span className="theme-color"></span>
                    </h2>
                    <div className="section-description">
                      <p className="mb-0">{galleryDetail?.[0]?.gallery_desc}</p>
                    </div>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {galleryDetail?.map((item, index) => (
                <div key={index} className="col-lg-6 col-md-6 col-12 mb-4">
                  <div
                    className="gallery-image"
                    style={{
                      backgroundImage: `url(${item?.gallery_image})`,
                      height: "350px",
                      width: "100%",
                      backgroundSize: "cover",
                      backgroundPosition: "top center",
                      backgroundRepeat: "no-repeat",
                    }}
                    aria-label={item?.gallery_title}
                  />
                </div>
              ))}
            </div>
          </>
        ) : (
          <h3 className="title text-uppercase text-center py-5">
            No Detail Found
          </h3>
        )}
      </div> */}

      <div className="container">
        {myLoader ? (
          <div className="text-center py-5">
            <Spinner />
          </div>
        ) : galleryDetail &&
          (galleryDetail?.gallery_title ||
            galleryDetail?.gallery_description ||
            galleryDetail?.images?.length > 0) ? (
          <>
            {/* Heading & Description */}
            {(galleryDetail?.gallery_title || galleryDetail?.gallery_description) && (
              <div className="row">
                <div className="offset-md-2 col-md-8 py-5">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-40">
                      {galleryDetail?.gallery_title && (
                        <h3 className="title text-uppercase ">
                          {galleryDetail?.gallery_title}
                          <span className="theme-color"></span>
                        </h3>
                      )}
                      {galleryDetail?.gallery_description && (
                        <div className="section-description">
                          {/* <p className="mb-0">{galleryDetail?.gallery_description}</p> */}
                          <p
                            className="mb-0"
                            dangerouslySetInnerHTML={{
                              __html: galleryDetail?.gallery_description || "",
                            }}
                          ></p>

                        </div>
                      )}
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Images */}
            {galleryDetail?.images?.length > 0 && (
              <div className="row">
                {galleryDetail.images.map((item, index) => (
                  <div key={index} className="col-lg-6 col-md-6 col-12 mb-4">
                    <div  className="gallery-image">
                       <img src={item.gallery_image} class="img-fluid" style={{ width: "100%", height: "auto" }} alt="" title="Invest Advices" />
                    </div>

                    {/* <div
                      className="gallery-image"
                      style={{
                        backgroundImage: `url(${item?.gallery_image})`,
                        height: "350px",
                        width: "100%",
                        backgroundSize: "cover",
                        backgroundPosition: "top center",
                        backgroundRepeat: "no-repeat",
                      }}
                      aria-label={galleryDetail?.gallery_title}
                    /> */}
                  </div>
                ))}
              </div>
            )}
          </>
        ) : (
          <h3 className="title text-uppercase text-center py-5">No Detail Found</h3>
        )}
      </div>


      <FooterWrapper />
    </div>
  );
}

export default GalleryDetail;
